import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import { store } from '../store'
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const configOptions = {
  apiKey: "AIzaSyCFtU1yOLpMBbzCYYrUsktT1HWNnAZa83o",
  authDomain: "visiteindormuseum.firebaseapp.com",
  databaseURL: "https://visiteindormuseum-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "visiteindormuseum",
  storageBucket: "visiteindormuseum.appspot.com",
  messagingSenderId: "291698331604",
  appId: "1:291698331604:web:8d1471b810d9c7abf01041",
  measurementId: "G-4MN32CXB6G"
};

firebase.initializeApp(configOptions);

createApp(App)
  .use(router)
  .use(store)
  .mount('#app')
